import { IonChip, IonIcon, IonItem, IonLabel, IonSkeletonText, IonThumbnail } from "@ionic/react";
import { banOutline, refreshOutline } from "ionicons/icons";
import { useDeviceQuery } from "../query/deviceQuery";
import styles from './DeviceListItem.module.css';
import { MouseEventHandler } from "react";
import DeviceConnectivityChip from './DeviceConnectivityChip';
import { useTranslation } from 'react-i18next';

interface DeviceListItemProps {
    deviceId: string;
    onClick?: MouseEventHandler<Element>;
}

const DeviceListItem: React.FC<DeviceListItemProps> = ({ deviceId, onClick }) => {
    const { t } = useTranslation('components');
    const deviceQuery = useDeviceQuery(deviceId);

    if (deviceQuery.isLoading) {
        return <IonItem button={true} detail={true} routerLink={onClick ? undefined : `/devices/${deviceId}`} onClick={onClick} className={styles.item}>
            <IonThumbnail slot="start">
                <IonSkeletonText animated={true}></IonSkeletonText>
            </IonThumbnail>
            <IonLabel>
                <h2>{deviceId}</h2>
                <p><IonSkeletonText animated={true} style={{ width: '160px' }} /></p>
                <IonChip color="medium" style={{ marginLeft: 0 }}>
                    <IonLabel><IonSkeletonText animated={true} style={{ width: '75px' }} /></IonLabel>
                </IonChip>
            </IonLabel>
        </IonItem>
    }
    else if (deviceQuery.isError) {
        return <IonItem button={true} detail={true} detailIcon={refreshOutline} onClick={() => deviceQuery.refetch()} className={styles.item}>
            <IonThumbnail slot="start">
                <img src="/assets/device/onlycat-device.png" alt={t('device_list_item.onlycat_device')} />
            </IonThumbnail>
            <IonLabel>
                <h2>{deviceId}</h2>
                <IonChip color="danger" style={{ marginLeft: 0 }}>
                    <IonIcon icon={banOutline} />
                    <IonLabel>{t('device_list_item.unavailable')}</IonLabel>
                </IonChip>
            </IonLabel>
        </IonItem>
    }
    else {
        const device = deviceQuery.data;

        return <IonItem button={true} detail={true} routerLink={onClick ? undefined : `/devices/${deviceId}`} onClick={onClick} className={styles.item}>
            <IonThumbnail slot="start">
                <img src="/assets/device/onlycat-device.png" alt={t('device_list_item.onlycat_device')} />
            </IonThumbnail>
            <IonLabel>
                <h2>{device.deviceId}</h2>
                <p>{device.description}</p>
                <DeviceConnectivityChip
                    deviceId={device.deviceId}
                    connectivity={device.connectivity}
                    style={{ marginLeft: 0 }}
                />
            </IonLabel>
        </IonItem>
    }
};

export default DeviceListItem;
